"use client";

import React, { BaseSyntheticEvent, MouseEventHandler, useCallback } from "react";

import Typography from "@mui/material/Typography";
import { useParams } from "next/navigation";

import { GlobalPathParams } from "~/app/[locale]/types";
import { FooterSocialLinksItemProps } from "~/bff/components/FooterSocialLinksItem";
import { CombinedLink } from "~/components/combined-link/component";
import { ONETRUST_MANAGE_COOKIES_LINK } from "~/constants/onetrust";
import { getTestAutomationProps } from "~/helpers/test-automation-props";
import { useLink } from "~/hooks/use-link/hook";

import { LINK_ITEM_CLASSES } from "./constants";
import { LinkItemContainer } from "./styled";

export const LinkItem = ({
  link,
  target,
}: FooterSocialLinksItemProps & { target?: string }): React.ReactElement => {
  const { locale } = useParams<GlobalPathParams>();

  const { shouldDisableLink } = useLink(link?.url ?? "", locale);
  const idValue = link?.label?.replace(" ", "-").toLowerCase();

  const isManageCookiesLink = link?.url === ONETRUST_MANAGE_COOKIES_LINK;

  const onManageCookiesClicked = useCallback((e: BaseSyntheticEvent) => {
    e.preventDefault();
    e.stopPropagation();
    OneTrust?.ToggleInfoDisplay?.();
  }, []);

  const onFooterLinkClick = useCallback<MouseEventHandler>(
    (e) => {
      if (isManageCookiesLink) {
        onManageCookiesClicked(e);
      }
    },
    [isManageCookiesLink, onManageCookiesClicked],
  );

  return (
    <LinkItemContainer
      {...getTestAutomationProps(`link`)}
      id={`footer-link-${idValue}`}
    >
      <CombinedLink
        className={LINK_ITEM_CLASSES.anchor}
        href={link?.url ?? ""}
        target={target}
      >
        <Typography
          onClick={onFooterLinkClick}
          variant="caption"
          {...(shouldDisableLink && {
            role: "presentation",
          })}
        >
          {link?.label}
        </Typography>
      </CombinedLink>
    </LinkItemContainer>
  );
};
